// constants/fonts.js - Font constants for digital business cards
// Shared between individual and team plans

// Curated list of professional fonts suitable for digital business cards
// Organized by categories for better UX
export const CURATED_FONTS_CATEGORIZED = {
    'Modern & Clean': [
        { name: 'Inter', category: 'sans-serif', variants: ['400', '500', '600', '700'] }, // Default
        { name: 'Roboto', category: 'sans-serif', variants: ['400', '500', '600', '700'] },
        { name: 'Poppins', category: 'sans-serif', variants: ['400', '500', '600', '700'] },
        { name: 'Montserrat', category: 'sans-serif', variants: ['400', '500', '600', '700'] },
        { name: 'Work Sans', category: 'sans-serif', variants: ['400', '500', '600', '700'] },
    ],
    'Professional': [
        { name: 'Playfair Display', category: 'serif', variants: ['400', '600', '700'] },
        { name: 'Merriweather', category: 'serif', variants: ['400', '600', '700'] },
        { name: 'EB Garamond', category: 'serif', variants: ['400', '600', '700'] },
        { name: 'Libre Baskerville', category: 'serif', variants: ['400', '700'] },
        { name: 'Lora', category: 'serif', variants: ['400', '600', '700'] },
    ],
    'Bold & Creative': [
        { name: 'Bebas Neue', category: 'display', variants: ['400'] },
        { name: 'Righteous', category: 'display', variants: ['400'] },
        { name: 'Archivo Black', category: 'display', variants: ['400'] },
        { name: 'Bungee', category: 'display', variants: ['400'] },
        { name: 'Fredoka', category: 'display', variants: ['400', '500', '600'] },
    ],
    'Friendly & Personal': [
        { name: 'Comfortaa', category: 'sans-serif', variants: ['400', '500', '600', '700'] },
        { name: 'Quicksand', category: 'sans-serif', variants: ['400', '500', '600', '700'] },
        { name: 'Nunito', category: 'sans-serif', variants: ['400', '500', '600', '700'] },
        { name: 'Dancing Script', category: 'handwriting', variants: ['400', '500', '600', '700'] },
        { name: 'Caveat', category: 'handwriting', variants: ['400', '500', '600', '700'] },
    ]
};

// Flatten the categorized structure to a flat array for backward compatibility
// Convert 'name' to 'family' for consistency with existing code
export const CURATED_FONTS = Object.values(CURATED_FONTS_CATEGORIZED)
    .flat()
    .map(font => ({
        family: font.name,
        category: font.category,
        variants: font.variants
    }));

/**
 * Get the correct variants for a font from the curated list
 * @param {string} fontFamily - The font family name
 * @returns {Array<string>} Array of font weights
 */
export const getFontVariants = (fontFamily) => {
    const font = CURATED_FONTS.find(f => f.family === fontFamily);
    if (font && font.variants) {
        return font.variants;
    }
    // Default variants if font not found in curated list
    return ['400', '500', '600', '700'];
};

